<template>
  <v-list-item class="mx-4 border" height="45px" :style="{ 'background-color': level === 1 ? '#eaeaea' : '#f7f7f7' }">
    <v-row no-gutters class="justify-center align-center">
      <v-col cols="5">
        <v-list-item-content>
          <v-list-item-title class="text-left">
            <v-tooltip bottom color="font">
              <template #activator="{ on }">
                <div class="pl-11 text-truncate font-weight-regular" v-on="on">
                  <v-row no-gutters align="center">
                    <v-col cols="auto" class="pr-3">
                      <permissions-layer-icon :layer-type="layerType" />
                    </v-col>
                    <v-col cols="auto">{{ name }}</v-col>
                  </v-row>
                </div>
              </template>
              {{ name }}
            </v-tooltip>
          </v-list-item-title>
        </v-list-item-content>
      </v-col>
      <v-col cols="7">
        <v-row no-gutters class="justify-center align-center">
          <v-col cols="6">
            <v-row class="justify-center" no-gutters>
              <v-col cols="auto">
                <div :style="{ width: '150px' }">
                  <permissions-select-users v-bind="$props" valueKey="main_value" @update:value="mainValue = $event" />
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row v-if="isVectorLayer" class="justify-center" no-gutters>
              <v-col cols="auto">
                <permissions-checkbox-users
                  v-bind="$props"
                  valueKey="attachments_and_comments_value"
                  :class="[checkboxPaddingClass]"
                  :disabled="isCommentsCheckboxDisabled"
                ></permissions-checkbox-users>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-list-item>
</template>

<script>
import { get } from 'vuex-pathify';
import PermissionsLayerIcon from '@/components/PermissionsLayerIcon';
import PermissionsSelectUsers from '@/components/PermissionsSelectUsers';
import PermissionsCheckboxUsers from '@/components/PermissionsCheckboxUsers';

export default {
  name: 'UserGroupsPermissionsDialogLayersItem',
  components: {
    PermissionsLayerIcon,
    PermissionsSelectUsers,
    PermissionsCheckboxUsers,
  },
  props: {
    group: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    mainValue: undefined,
  }),
  computed: {
    layers: get('layers/layers'),
    layerType() {
      const layer = this.layers[this.id];
      const layerType = layer.geometry_type || layer.service_type || '';
      return layerType;
    },
    isVectorLayer() {
      return this.type === 'features_layer';
    },
    checkboxPaddingClass() {
      return this.level > 0 ? `pl-${this.level * 6}` : null;
    },
    isCommentsCheckboxDisabled() {
      return this.mainValue == '0';
    },
  },
};
</script>

<style lang="scss" scoped>
.border {
  @include border(top);
  @include border(left);
  @include border(right);
  &:last-child {
    @include border(bottom);
  }
}
</style>
